import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { applicationLogger } from "../../../../logging/logger";
import { AdminApi } from "../../../../services/admin-api";
import { TicketDatumViewModel } from "../../../../models/ticket-datum-view-model";
import * as moment from "moment";
import { Kiosk } from "../../../../models/kiosk";
import { I18N } from "aurelia-i18n";
import { DataRequestViewModel } from "../../../../models/data-request-view-model";

@autoinject
export class TicketStockChart extends BaseDeviceChart {

	estimatedStockLevel: number;
	constructor(api: AdminApi, i18N: I18N) {
		super(api);
	}

	activate(kiosk: Kiosk) {
		this.bindKiosk(kiosk);
	}

	attached() {
		setTimeout(() => {
			this.isAttached = true;
		},
			100);
	}

	protected async getDataInternal(viewModel: DataRequestViewModel) {
		// ReSharper restore InconsistentNaming
		this.active = true;
		let response = await this.api.getTicketStockData(viewModel);

		if (response.success && response.data) {
			this.processData(response.data);
		} else {
			applicationLogger.error(response.message);
		}

		this.active = false;
	}

	protected processData(ticketData: TicketDatumViewModel[]) {


		this.hasData = ticketData.length > 0;

		if (this.hasData) {
			this.estimatedStockLevel = ticketData[ticketData.length - 1].estimatedRemaining;
		}
		
		setTimeout(() => {
			if (this.hasData) {
				this.chartData.labels = [];
				this.chartData.datasets[0].data = [];

				// Add more measurement data here
				//this.chartData.datasets[1].data = [];
				ticketData.forEach((item: TicketDatumViewModel) => {
					applicationLogger.debug(`Processing ticket datum: ${JSON.stringify(item)}`);

					// convert to the kiosk's timezone
					var timeZoneDate = new Date(item.created.toLocaleString('en-US', { timeZone: item.timeZone }));
					this.chartData.labels.push(moment(timeZoneDate).format('MM/DD/YYYY h:mm A'));

					// Add the battery voltage so it can be plotted
					this.chartData.datasets[0].data.push(item.estimatedRemaining);

					// Add more measurement data here
					//this.chartData.datasets[1].data.push(this.convertTemperature(item.data.temperature));
				});
				this.chart.refreshChart();
			}
		}, 250);

	}

	protected configureChartAxes() {

		this.chartData = {
			labels: [],
			datasets: [
				{
					label: "Estimated Count",
					backgroundColor: "rgba(0,0,255,0.2)",
					borderColor: "rgba(0,0,255,1)",
					pointColor: "rgba(0,0,255,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(220,220,220,1)",
					yAxisID: "EstimatedRemaining",
					data: []
				},

				// Add more measurement data here
				//{
				//	label: `Temperature (${this.getTemperatureSymbol()})`,
				//	backgroundColor: "rgba(220,220,220,0.2)",
				//	borderColor: "rgba(220,220,220,1)",
				//	pointColor: "rgba(220,220,220,1)",
				//	pointStrokeColor: "#fff",
				//	pointHighlightFill: "#fff",
				//	pointHighlightStroke: "rgba(151,187,205,1)",
				//	yAxisID: "Temperature",
				//	data: []
				//},
			]
		};
	}

	public async onTabSelected(e: any) {


		if (e.detail == "#ticketStockBasicTab") {
			await this.getGraphData(this.days.value);
		}

		if (e.detail == "#ticketStockAdvancedTab") {
			await this.getData()
		}
	}

	protected configureChartOptions() {
		this.chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			lineTension: 0.4,
			hover: {
				mode: "dataset"
			},
			legend: {
				display: true
			},
			scales: {
				xAxes: [
					{
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Timestamp"
						}
					}
				],
				yAxes: [
					{
						id: "EstimatedRemaining",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Estimated Count"
						},
						//ticks: {
						//	beginAtZero: true
						//},
						position: "left"
					},
					// Add more measurement data here
					//{
					//	id: "Temperature",
					//	display: true,
					//	scaleLabel: {
					//		display: true,
					//		labelString: "Temperature"
					//	},
					//	position: "right"
					//}
				]
				
			}
		};
	}
}
